import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFInput, VFText, IconTypes } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Images } from '../../../Themes';
import { CUSTOM_AMOUNT_VALIDATION_STATUS } from '../../Utils/customAmountValidationStatus';

import styles from './CustomAmount.Styles';

const getStyle = (
  customAmount,
  customAmountMaximum,
  currency,
  customAmountValidation,
  theme,
  stylesParam,
) => {
  if (
    customAmount.length === 0 ||
    customAmountValidation !== CUSTOM_AMOUNT_VALIDATION_STATUS.MAX_ERROR
  ) {
    return {
      hint_title: 'custom_auto_top_up_field_lower_hint',
      hint_style: stylesParam.hintNormalStyle(theme),
      baseColor: theme.colors.textInput.default.baseColor,
      tintColor: theme.colors.textInput.default.tintColor,
      selectionColor: theme.colors.textInput.default.selectionColor,
      textColor: theme.colors.textColor,
      isShowCurrency: true,
      inputStyle: { paddingRight: 25 },
      placeHolders: [customAmountMaximum, currency],
    };
  }
  return {
    hint_title: 'custom_auto_top_up_field_lower_hint_error',
    hint_style: styles.hintErrorStyle(theme),
    baseColor: theme.colors.textInput.error.baseColor,
    tintColor: theme.colors.textInput.error.tintColor,
    selectionColor: theme.colors.textInput.error.selectionColor,
    textColor: theme.colors.textInput.error.baseColor,
    isShowCurrency: false,
    inputStyle: { paddingRight: 35 },
    placeHolders: [customAmountMaximum, currency],
  };
};

const CustomAmount = ({
  onChangeCustomAmount,
  customAmount,
  currency,
  customAmountValidation,
  customAmountMaximum,
}) => {
  const theme = useTheme();

  const { hint_title, hint_style, isShowCurrency, inputStyle, placeHolders, ...textStyle } =
    getStyle(customAmount, customAmountMaximum, currency, customAmountValidation, theme, styles);

  return (
    <View style={styles.containerStyle}>
      <VFInput
        upperLabel="custom_auto_top_up_field_upper_hint"
        label="custom_auto_top_up_field_hint"
        value={customAmount}
        onChangeText={onChangeCustomAmount}
        {...textStyle}
        testID={FrameworkTestKeys.CustomAmount}
        style={inputStyle}
        keyboardType="number-pad"
        maxLength={`${customAmountMaximum}`.length}
      />
      {isShowCurrency ? (
        <VFText
          testID={FrameworkTestKeys.CurrencySymbol}
          style={styles.currencyStyle(theme)}
          localize={false}
          i18nKey={currency}
        />
      ) : (
        <Icon
          type={IconTypes.image}
          testID={FrameworkTestKeys.IcRedTriangle}
          name={Images.ic_red_triangle}
          size={29}
          style={styles.errorTriangleStyle(theme)}
        />
      )}

      <VFText style={hint_style} i18nKey={hint_title} placeHolders={placeHolders} />
    </View>
  );
};
CustomAmount.defaultProps = {
  onChangeCustomAmount: () => {},
  customAmount: '',
  currency: '',
  customAmountValidation: CUSTOM_AMOUNT_VALIDATION_STATUS.REGEX_ERROR,
};

CustomAmount.propTypes = {
  onChangeCustomAmount: PropTypes.func.isRequired,
  customAmount: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  customAmountValidation: PropTypes.oneOf([
    CUSTOM_AMOUNT_VALIDATION_STATUS.MAX_ERROR,
    CUSTOM_AMOUNT_VALIDATION_STATUS.REGEX_ERROR,
    CUSTOM_AMOUNT_VALIDATION_STATUS.VALID,
  ]),
  customAmountMaximum: PropTypes.number.isRequired,
};
export { getStyle };

export default CustomAmount;
